import { render, staticRenderFns } from "./ModalCustomerIneligible.vue?vue&type=template&id=6c759a4f&"
import script from "./ModalCustomerIneligible.vue?vue&type=script&lang=js&"
export * from "./ModalCustomerIneligible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports